import React, { PureComponent } from 'react';
import { autobind } from 'core-decorators';
import { styled, StyleSheet, insertCss } from '@rexlabs/styling';
import ReactMapGL, { Marker, NavigationControl } from 'react-map-gl';
import types from 'prop-types';
import Pin from './pin';

const styles = StyleSheet({
  marker: {
    width: '1.5rem',
    height: '1.5rem',
    display: 'block',
    left: '-.5rem',
    top: '-.5rem',
    position: 'relative',
    borderRadius: '3rem 3rem 0',
    transform: 'rotate(45deg)',
    border: '1px solid #fff'
  },
  navControl: {
    right: 10,
    top: 10,
    position: 'absolute'
  }
});

insertCss(`
  .map__container > div:first-child {
    width: 100% !important;
  }
  
  .modal-container .map__container > div:first-child {
    max-height: 60vh;
  }
`);

const mapStyle = {
  version: 8,
  sources: {
    'raster-tiles': {
      type: 'raster',
      tiles: [
        'https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}.png'
      ],
      tileSize: 256
    }
  },
  layers: [
    {
      id: 'simple-tiles',
      type: 'raster',
      source: 'raster-tiles',
      minzoom: 0,
      maxzoom: 22
    }
  ]
};

@styled(styles)
@autobind
class Map extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      viewport: {
        width: '100%',
        position: 'relative',
        height: props.height,
        minHeight: '210px',
        longitude: Number(this.props.longitude),
        latitude: Number(this.props.latitude),
        zoom: this.props.zoom
      },
      propertyLatLong: {
        latitude: Number(this.props.latitude),
        longitude: Number(this.props.longitude)
      }
    };
  }

  componentDidMount() {
    this.setState({
      viewport: {
        ...this.state.viewport,
        width: '100%',
        height: this.props.height
      }
    });
  }

  handleViewportChange = (viewport) => {
    this.setState({
      viewport: {
        ...viewport,
        height: this.props.height
      }
    });
  };

  render() {
    const { markerColor, styles: s } = this.props;
    const { longitude, latitude } = this.state.propertyLatLong;

    return (
      <div className={'map__container'}>
        <ReactMapGL
          mapStyle={mapStyle}
          {...this.state.viewport}
          onViewportChange={this.handleViewportChange}
          scrollZoom={false}
          touchZoom={false}
        >
          <NavigationControl showCompass={false} {...s('navControl')} />
          <Marker latitude={latitude} longitude={longitude} draggable={false}>
            <Pin markerColor={markerColor} />
          </Marker>
        </ReactMapGL>
      </div>
    );
  }
}

Map.propTypes = {
  latitude: types.string.isRequired,
  longitude: types.string.isRequired,
  zoom: types.number,
  mapStyle: types.string,
  markerColor: types.string
};

Map.defaultProps = {
  latitude: -27.452773,
  longitude: 153.046992,
  zoom: 12,
  height: '100%',
  markerColor: '#2baee9'
};

export default Map;
window.__Components.Map = Map;
